import React from "react";
import { connect } from "react-redux";
import IngresoActions from "../../../stores/ingreso/Actions";
import CustomInput from "../../../components/CustomForm/CustomInput";
import CustomSelect from "../../../components/CustomForm/CustomSelect";
import {
  FormWrapper,
  Form,
  FormGroup,
} from "../../../components/CustomForm/FormStyles";
import useEmpresa from "../../../hooks/useEmpresa";
import {
  dataMotivoEgreso,
  dataCausaInternamiento,
  dataTipoServicioCierreCuentas,
} from "../../../utils/LocalData";

const AutorizacionIngresoDetalle = (props) => {
  const { formCierreCuentasData } = props;

  const empresa = useEmpresa();

  return (
    <FormWrapper borderColor={empresa?.COLOR_PRINCIPAL}>
      <Form>
        <FormGroup>
          <CustomInput
            type={"text"}
            placeholder={"Número de ingreso"}
            label={"Número de ingreso"}
            value={formCierreCuentasData?.secuencialIngreso}
            disabled={true}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"date"}
            placeholder={"Fecha salida"}
            label={"Fecha salida"}
            value={formCierreCuentasData?.fechaSalida}
            disabled={true}
          />
        </FormGroup>
        <FormGroup>
          <CustomSelect
            options={dataMotivoEgreso}
            showDefaultOption={true}
            label={"Motivo Egreso"}
            value={formCierreCuentasData?.motivoEgreso}
            disabled={true}
          />
        </FormGroup>
        <FormGroup>
          <CustomSelect
            options={dataCausaInternamiento}
            showDefaultOption={true}
            label={"Causa de internamiento"}
            value={formCierreCuentasData?.causaInternamiento}
            disabled={true}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"date"}
            placeholder={"Fecha de servicio"}
            label={"Fecha de servicio"}
            value={formCierreCuentasData?.fechaServicio}
            disabled={true}
          />
        </FormGroup>
        <FormGroup>
          <CustomSelect
            options={dataTipoServicioCierreCuentas}
            label={"Tipo de Servicio"}
            value={formCierreCuentasData?.tipoServicio}
            required={true}
            showRequired={false}
            showDefaultOption={true}
            disabled={true}
          />
        </FormGroup>
      </Form>
    </FormWrapper>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formCierreCuentasData: state.ingreso.formCierreCuentasData,
  formCierreCuentasLoading: state.ingreso.formCierreCuentasLoading,
});

const mapDispatchToProps = {
  formCierreCuentas: IngresoActions.formCierreCuentas,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(AutorizacionIngresoDetalle);
